export default __webpack_public_path__ + "static/media/loading-image.5aa48301.gif";